class DatePipe {
    transform(timestamp, onlyDate = false) {
        const hasSeconds = String(timestamp).length === 13;
        const mul = hasSeconds ? 1 : 1000;
        const returnDate = onlyDate
            ? new Date(timestamp * mul).toString()
            : new Date(timestamp * mul).toLocaleString();
        return returnDate;
    }
}

const datePipe = new DatePipe();
export default datePipe;
